var render, staticRenderFns
import script from "./Itable.vue?vue&type=script&lang=js&"
export * from "./Itable.vue?vue&type=script&lang=js&"
import style0 from "./Itable.vue?vue&type=style&index=0&id=3a38600e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38600e",
  null
  
)

export default component.exports